
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'Toast'
})
export default class extends Vue {
  private visible = false
  private message = ''
}
